export const SET_CRM_CURRENT_PAYMENT = 'SET_CRM_CURRENT_PAYMENT'
export const ADD_PAYMENT = 'ADD_PAYMENT'
export const LOAD_CRM_PAYMENT_STATUS = 'LOAD_CRM_PAYMENT_STATUS'